import React, { useState, useEffect } from "react";
import "./FormFieldsStyle.css";

const multiInputStore = {};

const MultiInputField = (props) => {
  const [value, setValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  let parsedData = {};
  try {
    parsedData = props.item?.data ? JSON.parse(props.item.data) : {};
  } catch {
    parsedData = {};
  }

  const isAnyoneRequired = parsedData.required === "Anyone";
  const valueKey = parsedData.value || null;
  const fieldKey = valueKey || props.item?.text || "field";

  const a14InputItems = (props.allItems || []).filter(
    (i) => i.uiCommand === "A14input"
  );
  const isMultiInput = a14InputItems.length > 1;

  const specialCharRegex = /^[0-9a-zA-Z\/, ]*$/;

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("inputValue") || "{}");
    if (stored.key1 !== undefined) {
      delete stored.key1;
      localStorage.setItem("inputValue", JSON.stringify(stored));
    }
  }, []);

  const handleChange = (e) => {
    const v = e.target.value;
    const trimmed = v.trim();
    let err = "";

    if (trimmed.length > 74) {
      err = "Maximum character limit is 74";
    } else if (trimmed.length > 0 && !specialCharRegex.test(trimmed)) {
      err = "Special characters not allowed";
    }

    setErrorMessage(err);
    setValue(v);

    const stored = JSON.parse(localStorage.getItem("inputValue") || "{}");
    delete stored.key1;
    if (valueKey) {
      if (trimmed.length > 0) stored[valueKey] = v;
      else delete stored[valueKey];
    }
    localStorage.setItem("inputValue", JSON.stringify(stored));

    // Dispatch immediately with current values (don't wait for state update)
    if (isMultiInput && isAnyoneRequired) {
      multiInputStore[fieldKey] = trimmed;
      const anyFilled = Object.values(multiInputStore).some((v) => v && v.length > 0);
      window.dispatchEvent(new CustomEvent("a15InputChange", {
        detail: { anyoneMode: true, valid: anyFilled && !err }
      }));
    } else {
      window.dispatchEvent(new CustomEvent("a15InputChange", {
        detail: { anyoneMode: false, valid: trimmed.length > 0 && !err }
      }));
    }
  };

  return (
    <div className="form-group" style={{ marginBottom: "8px" }}>
      <input
        type="text"
        className="form-control"
        disabled={props.disable}
        placeholder={isAnyoneRequired ? "(fill at least one)" : ""}
        onInput={handleChange}
      />
      {errorMessage && (
        <div style={{ color: "red", fontSize: "12px", paddingTop: "4px" }}>
          {errorMessage}
        </div>
      )}
    </div>
  );
};

export default MultiInputField;
